import(/* webpackMode: "eager", webpackExports: ["default"] */ "/workspace/purple-ventures/src/components/landing/sections/CTASection.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/workspace/purple-ventures/src/components/landing/sections/DifferenceSection.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/workspace/purple-ventures/src/components/landing/sections/FooterSection.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/workspace/purple-ventures/src/components/landing/sections/Header.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/workspace/purple-ventures/src/components/landing/sections/HeroSection.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/workspace/purple-ventures/src/components/landing/sections/HowItWorksFlowSection.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/workspace/purple-ventures/src/components/landing/sections/HowItWorksSection.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/workspace/purple-ventures/src/components/landing/sections/InvestorsSection.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/workspace/purple-ventures/src/components/landing/sections/StakeholdersSection.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/workspace/purple-ventures/src/components/landing/sections/TestimonialsSection.tsx");
